import { createAction } from 'redux-actions';
export var restrictLoggedOut = createAction('@@loggedOut/RESTRICT_ACCESS', function (payload) { return payload; });
// this is an easy way to wrap existing actions to check for logged out
// but do remember that any reducers/sagas need to handle the _wrapped_ action
// so you must have access to the original action type
// the whole type/function jugglery here is to ensure proper typings in the result
export var VERIFY_ACCESS = '@@loggedOut/VERIFY_ACCESS';
export var verifyLoggedOutAccess = function (restrictedActionName, actionCreator) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ({
            type: VERIFY_ACCESS,
            payload: {
                action: actionCreator.apply(void 0, args),
                restrictedActionName: restrictedActionName,
            },
        });
    };
};
//# sourceMappingURL=actionCreators.js.map